'use client';

import Link from 'next/link';
import styles from './index.module.scss';
import MainButton from '@/app/_components/Shared/MainButton';

export default function ConsultationSection() {
  return (
    <section className={styles.container}>
      <div className="container-wrapper">
        <div className={styles.content}>
          <h2 className={styles.title}>Book your free consultation</h2>
          <p className={styles.description}>
            Get expert advice on your PRO service needs. Our specialists are ready to help you navigate UAE government procedures with ease.
          </p>
          <Link href="/contact">
            <MainButton color="gradient">
              Book a Consultation
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </MainButton>
          </Link>
        </div>
      </div>
    </section>
  );
}
